import { Box } from "@mui/material";
import { SearchInput } from "Components/Transactions/TransactionsSearchBar/SearchInput";
import { TransactionFilter } from "Components/Transactions/TransactionsSearchBar/TransactionFilters/TransactionFilter";
import type { TransactionFilterManager } from "Components/Transactions/hooks/useTransactionFilterManager";

type Props = {
  filterManager: TransactionFilterManager;
};

export const TransactionFilterBar = ({ filterManager }: Props) => {
  const { searchPublicID, setSearchPublicID } = filterManager;

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <SearchInput value={searchPublicID} onChange={setSearchPublicID} />
      <TransactionFilter filterManager={filterManager} />
    </Box>
  );
};
